"use client";

import { FetchError } from "@saas/core/fetch/fetch-error/fetch-error";

import {
  postMetadataRecovery,
  TPostMetadataRecoveryInput,
  TPostMetadataRecoveryOutput,
} from "../../post-metadata-recovery/post-metadata-recovery.fetch";

import { useMutation } from "@tanstack/react-query";

export type TUsePostMetadataRecoveryMutationPayload =
  TPostMetadataRecoveryInput;

export type TUsePostMetadataRecoveryMutationData = TPostMetadataRecoveryOutput;

export const usePostMetadataRecoveryMutation = () => {
  return useMutation<
    TUsePostMetadataRecoveryMutationData,
    FetchError,
    TUsePostMetadataRecoveryMutationPayload
  >(async (payload: TUsePostMetadataRecoveryMutationPayload) => {
    return postMetadataRecovery(payload);
  });
};
